import {
  Box,
  CloseIcon,
  ComponentVersionsInherit,
  ComponentVersions_3_0,
  Dialog,
  DialogTitle,
  IconButton,
  OsDialogProps,
  styled,
} from 'opensolar-ui'
import React from 'react'

export const StyledDialog = styled(Dialog)({
  // override z-index to show on top of other dialogs
  zIndex: '2002 !important',
  '.MuiDialog-paper, .OSUI-Dialog-paper': {
    width: '100%',
    maxWidth: '864px',
  },
  '.MuiDialogTitle-root, .OSUI-DialogTitle-root': {
    color: '#4C4B53',
    fontWeight: 600,
    svg: {
      stroke: 'none',
    },
    borderBottom: 'none',
  },
})

type TemplateLibraryCardGridProps = {
  children: React.ReactNode
  padding?: string
}

export const TemplateLibraryCardGrid: React.FC<TemplateLibraryCardGridProps> = ({ children, padding = '20px' }) => (
  <Box
    padding={padding}
    display="grid"
    justifyItems="center"
    gridTemplateColumns="repeat(auto-fit, minmax(264px, 1fr))"
    gridGap={8}
  >
    {children}
  </Box>
)

type TemplateLibraryDialogShellProps = {
  children: React.ReactNode
  disableClose?: boolean
  footer?: React.ReactNode
  id?: string
  onClose: () => void
  open: boolean
  title: React.ReactNode
  transitionProps?: OsDialogProps['TransitionProps']
}

export const TemplateLibraryDialogShell: React.FC<TemplateLibraryDialogShellProps> = ({
  children,
  disableClose,
  footer,
  id,
  onClose,
  open,
  title,
  transitionProps,
}) => (
  <ComponentVersionsInherit versions={ComponentVersions_3_0}>
    <StyledDialog id={id} maxWidth={false} open={open} onClose={onClose} TransitionProps={transitionProps}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center" width="100%">
          <span>{title}</span>
          {!disableClose && (
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          )}
        </Box>
      </DialogTitle>
      {children}
      {footer}
    </StyledDialog>
  </ComponentVersionsInherit>
)
